/* power.off.svg.js */

"use strict";
module.exports = {
    icon: `
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <ellipse class="power-off-circle" fill-opacity="0" stroke="#000" stroke-width="6%" ry="45%" rx="45%" id="svg_1" cy="50%" cx="50%" fill="#fff"/>
        </svg>
    `,
};
